import "../App.css";

const TodoPrint = ({ list, deleteTask }) => {
  return (
    <ul>
      {list.map((item, index) => (
        <li key={index}>
          <div>
            <h3>{item.text}</h3>
            <p>{item.time}</p>
          </div>

          <button onClick={() => deleteTask(index)}>❌</button>
        </li>
      ))}
    </ul>
  );
}

export default TodoPrint;
